// Ondalık (kesiratlı) sayı girişi için tarayıcı-bağımsız yardımcılar.
//
// NEDEN: Kontrollü <input type="number"> alanlarında, içerik geçerli bir
// floating-point sayı DEĞİLSE (ör. ara değer "5." veya virgüllü "5,") tarayıcının
// .value getter'ı BOŞ string döner. WebKit/Safari bu durumda kontrollü reset ile
// görünen metni anında siler → kullanıcı ondalık ayraç bastığında yazı kaybolur.
// (Chrome/Blink ara metni tuttuğu için bu hatayı maskeler — bu yüzden yalnız
// Safari kullanıcılarında görülür.) Ayrıca Türkçe virgül "5,5" parseFloat ile 5'e
// düşer (sessiz veri kaybı).
//
// ÇÖZÜM: Decimal alanlarda type="text" + inputMode="decimal" kullan, state'i HAM
// string olarak tut (tarayıcı asla temizlemez), virgülü noktaya çevir, sadece
// commit anında sayıya çevir. Bu yardımcılar o normalizasyonu yapar.

/**
 * Kullanıcı girişini güvenli bir ondalık STRING'e normalize eder.
 * - Türkçe virgülü noktaya çevirir ("5,5" → "5.5")
 * - Yalnız rakam, tek ondalık nokta ve (yalnız baştaki) eksi bırakır
 * - Yarım girişi korur ("5." → "5.") — type="text" olduğundan temizlenmez
 * - Boş girişe izin verir (alanı silme)
 * @param {string|number|null|undefined} raw
 * @returns {string}
 */
export function normalizeDecimalInput(raw) {
  if (raw == null) return '';
  let s = String(raw).replace(/,/g, '.');      // TR ondalık virgül → nokta
  s = s.replace(/[^0-9.-]/g, '');              // sadece rakam, nokta, eksi
  const negative = s.startsWith('-');          // eksi yalnız başta geçerli
  s = s.replace(/-/g, '');
  const dot = s.indexOf('.');                  // tek ondalık nokta: ilkini tut
  if (dot !== -1) {
    s = s.slice(0, dot + 1) + s.slice(dot + 1).replace(/\./g, '');
  }
  return (negative ? '-' : '') + s;
}

/**
 * Ham girişi sayıya çevirir (virgül-güvenli). Geçersizse fallback döner.
 * @param {string|number|null|undefined} raw
 * @param {number} [fallback=0]
 * @returns {number}
 */
export function parseDecimal(raw, fallback = 0) {
  const n = parseFloat(normalizeDecimalInput(raw));
  return Number.isFinite(n) ? n : fallback;
}
